"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResurrectedEventArgs = void 0;
const EventType_1 = require("../EventType");
class ResurrectedEventArgs {
    constructor(resurrector) {
        this.resurrector = resurrector;
        this.__type = EventType_1.EventType.Resurrected;
        this.__typeName = "Resurrected";
    }
}
exports.ResurrectedEventArgs = ResurrectedEventArgs;
